import React, { useEffect } from 'react'
import GoldSiverHeader from '../HomePage/GoldSiverHeader'
import { useDispatch, useSelector } from 'react-redux'
import {getMailList} from '../../store/chat'

function InBox() {
    const dispatch = useDispatch()
    const mail_list = useSelector(state => state.chat.mail_list) || []
    
    useEffect(() => {
        dispatch(getMailList())
    }, [dispatch])
    
    return (
        <div>
            <GoldSiverHeader previous={'/home'} title='Mail List'>
                <section className="ar_work_area_section">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="ar_work_area_main">
                                    <div className="ar_work_area">
                                        <div className="ar_single_item_table_work heading">
                                            <div className="ar_work_single_text text heading">
                                                <p>Mail List</p>
                                            </div>
                                        </div>
                                        <div className="ar_workFlex_wrapper">
                                            {mail_list && mail_list.length > 0 ? (
                                                mail_list.map((item, index) => {
                                                    return (
                                                        <div key={index} className="ar_single_item_table_work hard w-100">
                                                            <div className="p-5 d-flex justify-content-between w-100 block-box">
                                                                <div className='d-flex gap-3 align-items-center'>
                                                                    <img src="/images/mock-19.png" alt="" />
                                                                    <h2>{item.name || item.title || 'No title'}</h2>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            ) : (
                                                <div className='notfound'>
                                                    No data found
                                                </div>
                                            )}
                                        </div>
                                        <div className="ar_work_btn">
                                            <div className="ar_work_single_btn">
                                                <img src="/images/work/input.png" alt="" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </GoldSiverHeader>
        </div>
    )
}

export default InBox
